var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"chips":"","multiple":"","label":"File input w/ chips"}}),_c('v-file-input',{attrs:{"small-chips":"","multiple":"","label":"File input w/ small chips"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }